<template>
  <div class="push-disable-control" :class="{ 'push-disable-control--active': showButton || message, 'push-disable-control--in-modal': inModal }">
    <button v-if="showButton"
            type="button"
            class="theme-btn theme-btn--primary theme-btn--small theme-btn--block push-disable-control__button"
            :disabled="state.busy"
            :aria-busy="state.busy ? 'true' : 'false'"
            data-push-disable
            @click.stop.prevent="disable">
      <i class="material-icons" aria-hidden="true">notifications_off</i>
      <span>{{ state.busy ? text('push_notifications_disabling', 'Disabling…') : text('disable_push_notifications', 'Disable push notifications') }}</span>
    </button>
    <p class="push-disable-control__status" :class="{ 'push-disable-control__status--error': state.error === 'disable_failed' }"
       role="status" aria-live="polite">{{ message }}</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { pushState, resolvePushState, disablePush } from '../helpers/accountPushState';

/**
 * "Disable push notifications" at the top of the header bell dropdown. Shown only while this
 * browser is subscribed (helpers/accountPushState), whether or not there are unread
 * notifications. Disables push for this browser only; notifications and their unread count are
 * left alone.
 */
export default {
  props: {
    // The mobile bottom sheet has its close button in the top corner: start below it.
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    state: pushState,
    justDisabled: false,
  }),
  computed: {
    ...mapGetters(['locales']),
    showButton() {
      return this.state.status === 'subscribed'
    },
    message() {
      if (this.state.error === 'disable_failed') {
        return this.text('push_notifications_disable_failed', 'Push notifications could not be disabled. Please try again.')
      }
      if (this.justDisabled && this.state.status === 'unsubscribed') {
        return this.text('push_notifications_disabled', 'Push notifications are disabled on this device.')
      }
      return ''
    },
  },
  mounted() {
    resolvePushState()
  },
  methods: {
    text(key, fallback) {
      return (this.locales && this.locales.common && this.locales.common[key]) || fallback
    },
    async disable() {
      if (this.state.busy) {
        return
      }
      this.justDisabled = await disablePush()
    },
  },
}
</script>

<style scoped>
.push-disable-control--active {
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}
.push-disable-control--in-modal.push-disable-control--active {
  margin-top: 24px;
  padding: 0 20px 12px;
}
.push-disable-control__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: normal;
}
.push-disable-control__button:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}
.push-disable-control__button .material-icons {
  font-size: 18px;
}
.push-disable-control__status:empty {
  display: none;
}
.push-disable-control__status {
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 1.3;
}
.push-disable-control__status--error {
  color: #c0392b;
}
</style>
